import { Injectable } from "@angular/core";
import {
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "src/app/services";
import { PermissionService } from "src/app/services/permission.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { RoutePaths } from "../shared/constants/routePaths.constants";

@Injectable({
    providedIn: "root",
})
export class AuthGuard {
    constructor(
        private router: Router,
        private authService: AuthService,
        private permissionService: PermissionService,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean> | boolean {
        if (this.authService.isLoggedIn()) {
            if (this.permissionService.isLoaded) {
                return true;
            }
            return this.permissionService
                .loadPermissions()
                .pipe(map(() => true));
        }

        this.router.navigate([RoutePaths.login], {
            queryParams: { returnUrl: state.url },
        });
        return false;
    }
}
